type Primitive = string | number | boolean | null | undefined
type NestedObject = { [key: string]: Primitive | NestedObject | NestedObject[] | Primitive[] }

export function getAllObjectValues<T extends NestedObject>(obj: T): Primitive[] {
  const values: Primitive[] = []

  function recurse(current: Primitive | NestedObject | NestedObject[] | Primitive[]): void {
    if (typeof current === "object" && current !== null) {
      if (Array.isArray(current)) {
        for (const item of current) {
          recurse(item)
        }
      } else {
        for (const key in current) {
          if (Object.prototype.hasOwnProperty.call(current, key)) {
            recurse(current[key])
          }
        }
      }
    } else {
      values.push(String(current).toLowerCase())
    }
  }

  recurse(obj)
  return values
}
